var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentComponent)?_c('div',{staticClass:"report-list"},[_c(_vm.currentComponent,{ref:"reportListViewComponent",tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }